export const texts = {
  back: {
    de: 'Zurück',
    en: 'Back'
  },
  noCurrentPosition: {
    de: 'keine Angaben zur aktuellen Position',
    en: 'no information on current position'
  },
  analysis: {
    de: 'Analyse',
    en: 'Analysis'
  },
  message: {
    de: 'Nachricht',
    en: 'Message'
  },
  jobsiteLink: {
    de: 'Jobsite-Link',
    en: 'Jobsite link'
  },
  subject: {
    de: 'Betreff',
    en: 'Subject'
  },
  close: {
    de: 'Schließen',
    en: 'Close'
  }
};
